/* Boolland — header nav scroll fade.
   The main nav (.bh-nav--scroll-bl) scrolls horizontally when it overflows.
   Fade its left/right edge to the header background — like the announcement
   ticker — but only on the side(s) with menu items scrolled out of view.

   The fade is drawn by two absolutely-positioned overlays inside
   .bh-header__main (already position:relative, and the mega panels'
   containing block). They are pinned to the nav's *measured* edges, so they
   sit exactly on the scroller edges regardless of the nav's full-bleed
   padding — and, unlike a CSS mask on the nav, they never clip the escaped
   mega dropdowns. Positions only change on resize (horizontal scrolling
   moves the content, not the scroller box), so scroll just toggles which
   side is visible. */
(function () {
  var FADE_WIDTH = 40;

  function overlays(nav) {
    if (nav._blFades) return nav._blFades;
    var main = nav.closest('.bh-header__main');
    if (!main) return null;
    var left = document.createElement('span');
    var right = document.createElement('span');
    left.className = 'bl-nav-fade bl-nav-fade--left';
    right.className = 'bl-nav-fade bl-nav-fade--right';
    left.setAttribute('aria-hidden', 'true');
    right.setAttribute('aria-hidden', 'true');
    main.appendChild(left);
    main.appendChild(right);
    nav._blFades = { main: main, left: left, right: right };
    return nav._blFades;
  }

  function position(nav) {
    var f = overlays(nav);
    if (!f) return;
    var navRect = nav.getBoundingClientRect();
    var mainRect = f.main.getBoundingClientRect();
    var top = navRect.top - mainRect.top;
    [f.left, f.right].forEach(function (el) {
      el.style.top = top + 'px';
      el.style.height = navRect.height + 'px';
      el.style.width = FADE_WIDTH + 'px';
    });
    f.left.style.left = (navRect.left - mainRect.left) + 'px';
    f.right.style.left = (navRect.right - mainRect.left - FADE_WIDTH) + 'px';
  }

  function visibility(nav) {
    var f = nav._blFades;
    if (!f) return;
    var overflow = nav.scrollWidth - nav.clientWidth > 1;
    var atStart = nav.scrollLeft <= 1;
    var atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1;
    f.left.classList.toggle('is-visible', overflow && !atStart);
    f.right.classList.toggle('is-visible', overflow && !atEnd);
  }

  function refresh(nav) { position(nav); visibility(nav); }
  function refreshAll() { document.querySelectorAll('.bh-nav--scroll-bl').forEach(refresh); }

  function init() {
    document.querySelectorAll('.bh-nav--scroll-bl').forEach(function (nav) {
      if (nav.dataset.blFadeBound) { refresh(nav); return; }
      nav.dataset.blFadeBound = '1';
      overlays(nav);
      nav.addEventListener('scroll', function () { visibility(nav); }, { passive: true });
      /* Re-pin the fades whenever the nav's box changes size — e.g. when the
         header search expands/collapses and the nav column shrinks/grows. This
         fires each frame of that width transition, so the fade tracks the nav's
         moving right edge instead of being stranded at its old position. */
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(function () { refresh(nav); }).observe(nav);
      }
      refresh(nav);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  window.addEventListener('load', refreshAll);
  window.addEventListener('resize', refreshAll);
  document.addEventListener('shopify:section:load', init);
})();
